import React from 'react';
import MaskedInput from 'react-text-mask';

export const PasslyMaskedInput = (props: any) => {
    const { inputRef, maskSize, maskRegex, ...other } = props;

    const mask = () => {
        let mask: RegExp[] = [];
        for (let i: number = 0; i < maskSize; i++) {
            mask.push(maskRegex);
        }
        return mask;
    };

    return (
        <MaskedInput
            {...other}
            ref={ref => {
                inputRef && inputRef(ref ? ref.inputElement : null);
            }}
            mask={mask}
            guide={false}
        />
    );
};
